import { render } from "./FormGroup.vue?vue&type=template&id=c72157bc"
import script from "./FormGroup.vue?vue&type=script&lang=js"
export * from "./FormGroup.vue?vue&type=script&lang=js"
script.render = render

export default script